<style lang="scss" scoped>
.page_header {
  .button {
    padding: 0.35rem 0.75rem;
    height: 2rem;
  }

  .icon.is-small .mdi {
    font-size: 16px;
  }
}

.receipt_details .bill_tables .footer_table .table.leftside tr td[data-v-ac24c7a6]:nth-child(1) {
  width: 0;
}

.button.has-text-info {
  width: auto !important;
}

.msg_div {
  width: auto !important;
}

.modal_table {
  table,
  th,
  td {
    width: 100%;
    border-collapse: collapse;
    border: 1px solid black;
    padding: 0.65rem 0.7rem;
    font-size: 1rem;
  }

  table {
    overflow-x: scroll;
    overflow-y: scroll;
  }

  td {
    display: table-cell;
    padding: 5px;
    color: black;
  }

  th {
    color: #fff;
    background-color: #56509f;
  }
}

.receipt_details {
  .receipt_heading {
    font-size: 1.3rem;
    font-weight: bold;
  }

  .sub_headings {
    color: seagreen;
  }

  .title.is-5 {
    color: black;
  }

  .hr_yellow {
    background-color: #191d38;
    height: 0.3rem;
  }

  .border_dashed {
    border-left: 1px dashed gray;
  }

  .customer_details,
  .franchisee_details {
    th {
      width: 10rem;
    }

    .table td,
    .table th {
      border: 0;
      padding: 0.3em 0.75em;
    }
  }

  .bill_tables {
    .table th {
      border: 1px solid #9a9a9a;
      background-color: #191d38;
      color: white;
      padding: 0.8em 0.75em;
    }

    .table td {
      padding: 0.8em 0.75em;
      border: 0.5px solid #9a9a9a;
    }

    caption {
      padding: 0.75rem;
      font-size: 1rem;
    }

    .footer_table {
      padding: 0 !important;

      .table td {
        padding: 0.25rem 0.4rem;
        border: 1px lightcyan;
      }

      .table.rightside tr {
        td {
          text-align: right;
        }
      }

      .table.leftside tr {
        // td:nth-child(1) {
        //   width: 12rem;
        // }
        td:nth-child(2) {
          padding-left: 1.5rem;
          width: 5rem;
        }
      }
    }
  }
}
</style>
<template>
  <div>
    <v-container fluid>
      <material-card icon="mdi-cart-arrow-right" inline title="Order summary">
        <router-link :to="{ name: 'wowKitOrderList', params: { franchiseeID: this.franchiseeID } }">
          <v-btn v-if="$vuetify.breakpoint.smAndUp" elevation="1" absolute right top> <v-icon left>mdi-arrow-left</v-icon>back</v-btn>
          <v-btn v-else fixed right fab small color="grey lighten-2" elevation="1" class="mr-n2 mt-10" style="opacity:.6;"> <v-icon>mdi-arrow-left</v-icon></v-btn>
        </router-link>
        <v-row>
          <!-- <v-col cols="12" md="6" v-if="franchisee">
            <v-simple-table>
              <tbody>
                <tr>
                  <td class="font-weight-bold body-2 subtitle">
                    Name :
                  </td>
                  <td>
                    {{ franchisee.companyName || '-' }}
                  </td>
                </tr>

                <tr v-if="franchisee.address1 != null ? true : false">
                  <td class="font-weight-bold body-2 subtitle">Fanchisee address:</td>
                  <td>
                    {{ franchisee.address1 || '-' }}
                  </td>
                </tr>
              </tbody>
            </v-simple-table>
          </v-col> -->
          <!-- <v-col cols="12" md="6">
            <v-simple-table>
              <tbody>
                <tr>
                  <td class="font-weight-bold body-2 subtitle">
                    Franchisee Category
                  </td>
                  <td>
                    {{ franchisee.modelID || '-' }}
                  </td>
                </tr>
              </tbody>
            </v-simple-table>
          </v-col> -->
        </v-row>
        <v-row>
          <v-col cols="12">
            <!-- <div class="d-flex justify-center">
              <v-subheader class="headline font-weight-bold">CASH MEMO/INVOICE</v-subheader>
            </div>
            <div class="d-flex justify-space-between">
              <v-subheader class="body-2 font-weight-bold"> Order ID: <span class="font-weight-medium ml-2">54334565432</span> </v-subheader>
              <v-subheader class="body-2 font-weight-bold"> Date & Time: <span class="font-weight-medium ml-2">2020-21-21</span> </v-subheader>
            </div> -->
            <v-row>
              <v-col cols="12" md="6">
                <v-card-component>
                  <v-img width="150" class="mb-5" src="https://cdn.fcglcdn.com/brainbees/images/n/fc_logo.jpg"></v-img>
                  <v-card-title class="text-decoration-underline">Billing Address</v-card-title>
                  <v-simple-table>
                    <tbody>
                      <tr>
                        <td class="font-weight-bold body-2 subtitle">
                          Franchisee Name :
                        </td>
                        <td>
                          {{ franchisee.companyName || '-' }}
                        </td>
                      </tr>

                      <tr>
                        <td class="font-weight-bold body-2 subtitle">Trust Name :</td>
                        <td>{{ franchisee ? franchisee.trustName : '-' }}</td>
                      </tr>
                      <tr>
                        <td class="font-weight-bold body-2 subtitle">Address :</td>
                        <td>
                          <span>{{ franchisee ? `${franchisee.address1} ${franchisee.city} ${franchisee.state} `: '-' }}</span>
                          <span>&nbsp;{{ franchisee ? franchisee.country : '-' }} -{{ franchisee ? franchisee.pincode : '-' }}</span>
                        </td>
                      </tr>

                      <tr>
                        <td class="font-weight-bold body-2 subtitle">GST No :</td>
                        <td>{{ franchisee ? franchisee.gstNo : '-' }}</td>
                      </tr>
                      <tr>
                        <td class="font-weight-bold body-2 subtitle">Contact Person :</td>
                        <td>
                          <span>{{ franchisee ? franchisee.firstname : '-' }}</span> &nbsp;
                          <span>{{ franchisee ? franchisee.lastname : '-' }}</span>
                        </td>
                      </tr>
                      <tr>
                        <td class="font-weight-bold body-2 subtitle">Mobile No :</td>
                        <td>
                          <span>{{ franchisee ? franchisee.mobileno : '-' }}</span>
                        </td>
                      </tr>
                      <tr>
                        <td width="30%" class="font-weight-bold body-2 subtitle">Email id :</td>
                        <td width="70%">
                          <span>{{ franchisee ? franchisee.email : '-' }}</span>
                        </td>
                      </tr>
                    </tbody>
                  </v-simple-table>
                </v-card-component>
              </v-col>
              <v-col cols="12" md="6">
                <v-card-component>
                  <v-card-title class="text-decoration-underline">
                    <span>{{ franchisee.companyName }}</span
                    ><br />
                    <span>{{ franchisee.WareHouseName }}</span>
                  </v-card-title>
                  <v-simple-table>
                    <tbody>
                      <tr>
                        <td class="font-weight-bold body-2 subtitle">GST No :</td>
                        <td>{{ franchisee.gstNo }}</td>
                      </tr>
                      <tr>
                        <td class="font-weight-bold body-2 subtitle">Contact No.</td>
                        <td>{{ franchisee.mobileno }}</td>
                      </tr>

                      <tr>
                        <td width="30%" class="font-weight-bold body-2 subtitle">Address :</td>
                        <td width="70%">{{franchisee.address1}} ${{franchisee.city}} {{franchisee.state}}{{franchisee.country}}-{{ franchisee.pincode }}</td>
                      </tr>
                    </tbody>
                  </v-simple-table>
                  <v-divider></v-divider>
                  <v-card-title class="text-decoration-underline">Shipping Address</v-card-title>
                  <v-simple-table>
                    <tbody>
                      <tr>
                        <td class="font-weight-bold body-2 subtitle">Ship to :</td>
                        <td>{{ this.franchisee.firstname }} {{ this.franchisee.lastname || '' }}</td>
                      </tr>
                      <tr>
                        <td class="font-weight-bold body-2 subtitle">Contact No.</td>
                        <td>
                          {{ this.franchisee.mobileno || '-' }}
                        </td>
                      </tr>

                      <tr>
                        <td width="30%" class="font-weight-bold body-2 subtitle">Address :</td>
                        <td width="70%">{{ franchisee ? `${franchisee.address1} ${franchisee.city} ${franchisee.state} `: '-' }}
                          &nbsp;{{ franchisee ? franchisee.country : '-' }} -{{ franchisee ? franchisee.pincode : '-' }}
                        </td>
                      </tr>
                    </tbody>
                  </v-simple-table>
                </v-card-component>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-card-component>
          <v-card-text class="pt-0 pr-1" :class="{ 'd-block py-3': $vuetify.breakpoint.xs, 'd-flex align-center': $vuetify.breakpoint.smAndUp }">
            <v-spacer></v-spacer>
            <v-btn large v-if="isCartData" color="pink white--text" elevation="1" :class="{ 'mt-2': $vuetify.breakpoint.xs }" @click="placeOrder()"
              >Confirm & Place order
              <v-icon right>mdi-shopping-music</v-icon>
            </v-btn>
          </v-card-text>
          <v-divider class=" my-0 " />
          <v-data-table
            :items-per-page="200"
            :headers="headers"
            :items="cartData.productsFromB2B"
          >
            <template slot="body.append" v-if="isCartData">
              <tr>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td v-if="this.GSTType!='IGST'"></td>
                <td class="font-weight-bold">Totals</td>
                <td class="font-weight-bold">&#x20b9; {{ cartData.totalAmount }}</td>
              </tr>
            </template>
            <template v-slot:no-data>
              <v-card-subtitle class="d-flex justify-center">No Data Available</v-card-subtitle>
            </template>
          </v-data-table>
        </v-card-component>
      </material-card>
      <loading-icon :value="isLoading" />
    </v-container>
  </div>
</template>

<script>
// @ is an alias to /src
import VCardComponent from '@/components/template/VCardComponent'
import MaterialCard from '@/components/template/MaterialCard'
import stores from '@/stores'
import constants from '@/utils/constants'
import _ from 'lodash'
export default {
  name: 'wowKitOrderSummary',
  props: ['franchiseeID'],
  components: {
    VCardComponent,
    MaterialCard
  },
  data () {
    return {
      isCartData: false,
      isLoading: false,
      constantKit: constants.KIT,
      invoiceProduct: [],
      kit: '',
      GSTType: 'IGST',
      cartData: {
        products: [],
        productsFromB2B: [],
        totalAmount: 0
      },
      headers: [
        { text: 'productID.', value: 'productID' },
        { text: 'Particulars / HSN.', value: 'HSNCode' },
        { text: 'MRP', value: 'mrp' },
        { text: 'Quantity', value: 'quantity' },
        { text: 'IGST (%)', value: 'gst' },
        { text: 'Discount (₹)', value: 'discount' },
        { text: 'Total (incL Tax)(₹)', value: 'totalPrice' }],
      productPrices: '',
      invoiceDetails: {},
      franchisee: {},
      cartItems: ''
    }
  },
  async created () {
    await this.getFranchisee()
    await this.getCardOrders()
    await this.getProductPrices()
  },
  computed: {
    updateHeaders: function () {
      if (this.isCartData) {
        if (this.cartData.productsFromB2B.length && _.isEqual(this.GSTType, 'IGST')) {
          return [
            { text: 'productID.', value: 'productID' },
            { text: 'Particulars / HSN.', value: 'HSNCode' },
            { text: 'MRP', value: 'mrp' },
            { text: 'Quantity', value: 'quantity' },
            { text: 'IGST (%)', value: 'gst' },
            { text: 'Discount (₹)', value: 'discount' },
            { text: 'Total (incL Tax)(₹)', value: 'totalPrice' }
          ]
        } else {
          return [
            { text: 'productID.', value: 'productID' },
            { text: 'Particulars / HSN.', value: 'HSNCode' },
            { text: 'MRP', value: 'mrp' },
            { text: 'Quantity', value: 'quantity' },
            { text: 'CGST (%)', value: 'cgst' },
            { text: 'SGST (%)', value: 'sgst' },
            { text: 'Discount (₹)', value: 'discount' },
            { text: 'Total (incL Tax)(₹)', value: 'totalPrice' }
          ]
        }
      } else {
        return [
          { text: 'productID.', value: 'productID' },
          { text: 'Particulars / HSN.', value: 'HSNCode' },
          { text: 'MRP', value: 'mrp' },
          { text: 'Quantity', value: 'quantity' },
          { text: 'IGST (%)', value: 'gst' },
          { text: 'Discount (₹)', value: 'discount' },
          { text: 'Total (incL Tax)(₹)', value: 'totalPrice' }
        ]
      }
    }
  },
  watch: {

  },
  methods: {
    getFranchisee: async function () {
      try {
        this.isLoading = true
        const { data } = await http.get(`${constants.API_URL}/api/franchisee/${this.franchiseeID}`)
        this.franchisee = data
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('Error While fetching Franchisee', errorMessage)
        this.lock = false
        this.hasClicked = false
        return this.$dialog.error({
          text: errorMessage,
          title: 'Error'
        })
      } finally {
        this.isLoading = false
      }
    },
    getCardOrders: async function () {
      let wowKitOrders = await stores.wowKitOrders.getWowKitOrders(this.franchiseeID)
      this.cartItems = wowKitOrders.cartItems
      this.cartData =
        wowKitOrders.find(o => {
          return o.id === Number(this.franchiseeID)
        }) || this.cartData
      this.isCartData = this.cartData.products.length ? true : this.isCartData
      this.cartItems =
        wowKitOrders.find(o => {
          return o.id === Number(this.franchiseeID)
        }) || this.cartData
      await stores.user.setWowKitOrder(this.cartData)
    },
    getProductPrices: async function () {
      try {
        this.isLoading = true
        let response = await http.post(`${constants.API_URL}/api/order/order-amount-from-b2b`, {
          kit: this.cartItems.products,
          b2bID: this.franchisee.b2bID
        })
        if (!response.data.length) {
          this.$dialog.error({
            text: response.data,
            title: 'Error'
          })
          this.$router.push({
            name: 'wowKitOrderList',
            params: {
              franchiseeID: this.franchisee.id
            }
          })
        }
        let allProducts = response.data
        if (allProducts.length > 0) {
          this.cartData.totalAmount = 0
          this.cartData.productsFromB2B = []
          for (let order of allProducts) {
            this.cartData.totalAmount = Number(this.cartData.totalAmount) + Number(order.amountOrder)
            this.cartData.totalAmount = Number(this.cartData.totalAmount).toFixed(2)
            this.productPrices = order.orderPo.purchaseDetail
            let products = order.orderPo.purchaseDetail
            for (let product of products) {
              let productData = {}
              productData.productID = product.id
              productData.HSNCode = `${product.productDetail.name} (${product.HSNCode})`
              productData.actualPrice = product.pricing.actualPrice.toFixed(2)
              productData.quantity = product.quantity
              productData.discount = product.pricing.discount.toFixed(2)
              productData.mrp = product.pricing.mrp
              productData.totalPrice = product.totalPrice.toFixed(2)
              productData.orderedQuantity = product.orderedQuantity
              productData.gst = '-'
              this.GSTType = product.GSTType
              productData.GSTType = product.GSTType
              if (product.GSTType) {
                if (_.isEqual(product.GSTType, 'IGST')) {
                  productData.gst = `${product.IGST} (${product.GSTType})`
                } else {
                  productData.gst = `${product.CGST}+${product.SGST} (${product.GSTType})`
                }
              }
              productData.sgst = `${product.SGST}`
              productData.cgst = `${product.CGST}`
              this.cartData.productsFromB2B.push(productData)
            }
          }
          this.headers = this.updateHeaders
        }
      } catch (e) {
        console.log(e)
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.$dialog.error({
          text: errorMessage,
          title: 'Error'
        })
        console.log('In catch block')
        this.$router.push({
          name: 'wowKitOrderList',
          params: {
            franchiseeID: this.franchisee.id
          }
        })
      } finally {
        this.isLoading = false
      }
    },
    placeOrder: function () {
      this.$dialog.confirm({
        title: 'Place Order',
        text: 'Are you sure you want to place this order?',
        actions: {
          false: {
            text: 'No'
          },
          true: {
            color: 'success',
            text: 'Yes',
            handle: async () => {
              try {
                const Products = []

                // let serviceability = {
                //   data: {}
                // }
                // try {
                //   serviceability = await http.get(`${constants.API_URL}/api/pincode-check/${this.franchisee.pincode}`)
                // } catch (e) {
                //   console.log('e', e.message)
                //   serviceability.data = e
                // }
                // if (serviceability.data.statusCode !== 200) {
                //   return this.$dialog.error({
                //     text: '<b>Your pincode is not  serviceable!</b>',
                //     title: 'Error'
                //   })
                //   // this.$router.push({ path: 'wowKitOrderList', params: { franchiseeID: this.franchiseeID } })
                // }
                this.cartData.productsFromB2B.forEach(p => {
                  Products.push({
                    quantity: p.orderedQuantity,
                    productID: p.productID
                  })
                })
                const orderObj = {
                  franchiseeID: this.franchisee.id,
                  products: Products
                }
                this.isLoading = true
                const { data } = await http.post(`${constants.API_URL}/api/order/wow-kit`, orderObj)
                await stores.wowKitOrders.clearWowKitOrder(this.franchisee.id)
                this.kit = _.find(this.constantKit, item => _.isEqual(item.route, 'wow-kit'))
                const allOrders = data.map(obj => obj.orderID)
                this.$router.push({
                  name: 'wowKitOrderConfirmation',
                  params: {
                    franchiseeID: this.franchisee.id,
                    orderID: allOrders
                  }
                })
                this.isLoading = false
              } catch (e) {
                this.isLoading = false
                const errorMessage = (e && e.response && e.response.data.message) || e.message
                return this.$dialog.error({
                  text: errorMessage,
                  title: 'Error'
                })
              }
            }
          }
        }
      })
    }
  }
}
</script>
<style scoped>
.confirmBtn {
  position: absolute;
  bottom: 0.65rem;
}
</style>
